// ** Returns initials from string
export const getInitials = (str?: string) => str?.split(/\s/).reduce((response, word) => `${response}${word.slice(0, 1)}`, '') || ''
